import React from "react";
import PayoutFlowSteps from "./PayoutFlowSteps";

const steps = ["Upload File", "Review", "Verify", "Confirm"];

function PayoutBulkUploadFlowSteps({ activeStep }: { activeStep: number }) {
  return <PayoutFlowSteps steps={steps} activeStep={activeStep} />;
}

export default PayoutBulkUploadFlowSteps;
